import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-notification-recipients',
  templateUrl: './notification-recipients.component.html',
  styleUrls: ['./notification-recipients.component.css']
})
export class NotificationRecipientsComponent {

}
